import React from "react";

export default function Spacing() {
  return <div className="h-[238px] "></div>;
}